import React, { Component } from "react";
import Reveal from "./Reveal";

class About extends Component {
  render() {
    if (!this.props.data) return null;

    const { name, image, phone1, phone2, phoneDaune, email1, email2 } = this.props.data;
    const tel = (phone) => "tel:+40" + phone.replace(/\s/g, "").replace(/^0/, "");
    const { street, city, state, zip } = this.props.data.address;
    const profilepic = "images/" + image;

    return (
      <section id="about">
        <Reveal direction="up" duration={1000}>
        <div className="row">
          <div className="three columns">
            <picture>
              <source srcSet="images/logo.webp" type="image/webp" />
              <img className="profile-pic" src={profilepic} alt="KFY Auto" />
            </picture>
            <br />&nbsp;
          </div>
          <div className="nine columns main-col">
            <div className="row">
              <div className="columns contact-details">
                <h2>Detalii contact</h2>
                <p className="address">
                  <span>{`Nume: ${name}`}</span>
                  <br />&nbsp;
                  <span>
                    {`Adresa: ${street}`}
                    <br />
                    {`\u00a0${city}, ${state}, ${zip}`}
                  </span>
                  <br />&nbsp;
                  <span>Telefon: <a href={tel(phone1)}>{phone1}</a></span>
                  <br />&nbsp;
                  <span>Telefon: <a href={tel(phone2)}>{phone2}</a></span>
                  <br />&nbsp;
                  {phoneDaune && (
                    <>
                      <span>Constatare daune: <a href={tel(phoneDaune)}>{phoneDaune}</a></span>
                      <br />&nbsp;
                    </>
                  )}
                  <span>Email: <a href={"mailto:" + email1}>{email1}</a></span>
                  <br />&nbsp;
                  <span>Email: <a href={"mailto:" + email2}>{email2}</a></span>
                </p>
              </div>
              <div className="columns download">
                <div className="map-responsive">
                  <iframe
                    title="Harta service"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4051.395432890498!2d24.32437205081539!3d44.108754436042126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40ace186dba80473%3A0xbf0bbaa8ce717bb1!2sKfy%20Auto!5e0!3m2!1sen!2sro!4v1672838740447!5m2!1sen!2sro"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
              {/* <div className="columns download">
                <div className="map-responsive">
                  <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/lJIrF4YjHfQ?si=jkhGnKlS2t3Qqk6q&amp;controls=0&amp;mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        </Reveal>
      </section>
    );
  }
}

export default About;
